import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import ProductImage from '../../../common/exhibitingOrganisation/ProductImage';
import {DataDtmActions, ImageTypes} from '../../../common/Constants';
import Classes from '../../../common/Classes';
import StringFormatter from '../../../common/StringFormatter';
import Utils from '../../../common/Utils';
import mixpanelConstants from '../../../common/mixpanelConstants';
import {trackImpressions, trackMixpanelEvent} from '../../../common/MixpanelHelper';

const ProductCarouselItem = (props) => {
  const productRef = useRef();
  let mixpanelProps = {}
  useEffect(() => {
    if(props.mixpanelProps){
      mixpanelProps = JSON.parse(props.mixpanelProps)
    }
    const observer = trackImpressions(mixpanelConstants.eventName.productImpression, {
      ...mixpanelProps,
      ...(sessionStorage.getItem('component') && {component: sessionStorage.getItem('component')}),
      viewedElement: props.product.video?.id ? mixpanelConstants.element.productVideo : mixpanelConstants.element.productImage
    }, 0);
    if(productRef.current){
      observer.observe(productRef.current)
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  const trackProductInteractedEvent = (element) => {
    if(props.mixpanelProps){
      mixpanelProps = JSON.parse(props.mixpanelProps)
    }

    trackMixpanelEvent(mixpanelConstants.eventName.productInteracted,
      {
        ...mixpanelProps,
        element: element,
        component: mixpanelProps.component ?? sessionStorage.getItem('component'),
      });
  }

  const getProductDetailsUrl = (productUri, product) => {
    let productUrl;
    const environment = Utils.getCurrentEnvironment();
    if(!Utils.isDevEnvironment(environment) && !Utils.isShowEnvironment(environment) && product.name) {
      //replaces spaces with '-' from product name with meaning full name
      let productName = Utils.getSEOFriendlyName(product.name);
      productUrl = StringFormatter.format(productUri,
          product.exhibitingOrganisationId.concat('.', productName), product.id);
    } else {
      productUrl = StringFormatter.format(productUri, product.exhibitingOrganisationId, product.id);
    }
    return <div onClick={() => trackProductInteractedEvent(mixpanelConstants.element.productTitle)}>
      <a className="product-link" key={product.id} href={productUrl}
              data-dtm={props.imageDataDtm?.nameTag}
              data-dtm-actions={props.imageDataDtm ? DataDtmActions.click : null}
              data-dtm-attributes={props.imageDataDtm?.attributes}
              tabindex="-1"
    >{product.name}</a>
    </div>;
  };
  const getProductDetailsPageUrl = productDetailsUrlFormat => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className={Classes.productText} onClick={props.isEditAllowed ? () => {} : props.onClick}>
      {props.product.name ?
      (
        getProductDetailsUrl(productDetailsUrlFormat, props.product)
        ) : (
          <h4 className={Classes.textDanger}>* {props.translations.errorMessages.missing_field_product_multilingual_product_title}</h4>
        )}
    </div>
  );

  const displayProductName = () => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className={Classes.productText} onClick={props.isEditAllowed ? () => {} : props.onClick}>
      {props.product.name ? (
        <h4>{props.product.name}</h4>
        ) : (
          <h4 className={Classes.textDanger}>* {props.translations.errorMessages.missing_field_product_multilingual_product_title}</h4>
        )}
    </div>
  );

  const displayProducerLink = (producerDetails, producerUrlFormat) => {
    if (producerDetails === undefined || producerDetails === null) {
      return null;
    }
    return producerDetails.map((x) => {
      const producerUrl = StringFormatter.format(producerUrlFormat, x.id);
      return <li><a className="producer-link" key={x.id} href={producerUrl}>{`${x.firstName} ${x.lastName}`}</a></li>;
    });
  };

  const isVideoAvailable = !!props.product.videoId;
  return (
    <div style={{'--brand-color': window.reactSettingsProductDetails?.props.themes.brandPrimary}}>
      {props.product.id &&
        <div className={props.classNames} ref={productRef}>
          <MediaQuery minWidth={1199}>
            <ProductImage
              product={props.product}
              src={`${Utils.getProductVideoOrImageUrl(props.product)}?${new Date().getTime()}`}
              deviceType={props.deviceType.extraLarge}
              imageSize={ImageTypes.product}
              alt={props.translations.products.productImageAltText}
              isEditable={props.isEditAllowed}
              translations={props.translations.products}
              onClick={props.onClick}
              isRounded
              tags={props.tags}
              isInnovative={props.isInnovative}
              imageDataDtm={props.imageDataDtm}
              trackProductInteractedEvent={trackProductInteractedEvent}
              isNew={props.isNew}
              isVideoAvailable={isVideoAvailable}
            />
          </MediaQuery>
          <MediaQuery minWidth={992} maxWidth={1198}>
            <ProductImage
              product={props.product}
              src={`${Utils.getProductVideoOrImageUrl(props.product)}?${new Date().getTime()}`}
              deviceType={props.deviceType.large}
              imageSize={ImageTypes.product}
              alt={props.translations.products.productImageAltText}
              isEditable={props.isEditAllowed}
              translations={props.translations.products}
              onClick={props.onClick}
              isRounded
              tags={props.tags}
              isInnovative={props.isInnovative}
              imageDataDtm={props.imageDataDtm}
              trackProductInteractedEvent={trackProductInteractedEvent}
              isNew={props.isNew}
              isVideoAvailable={isVideoAvailable}
            />
          </MediaQuery>
          <MediaQuery minWidth={768} maxWidth={991}>
            <ProductImage
              product={props.product}
              src={`${Utils.getProductVideoOrImageUrl(props.product)}?${new Date().getTime()}`}
              deviceType={props.deviceType.tablet}
              imageSize={ImageTypes.product}
              alt={props.translations.products.productImageAltText}
              isEditable={props.isEditAllowed}
              translations={props.translations.products}
              onClick={props.onClick}
              isRounded
              tags={props.tags}
              isInnovative={props.isInnovative}
              imageDataDtm={props.imageDataDtm}
              trackProductInteractedEvent={trackProductInteractedEvent}
              isNew={props.isNew}
              isVideoAvailable={isVideoAvailable}
            />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
            <ProductImage
              product={props.product}
              src={`${Utils.getProductVideoOrImageUrl(props.product)}?${new Date().getTime()}`}
              deviceType={props.deviceType.mobile}
              imageSize={ImageTypes.product}
              alt={props.translations.products.productImageAltText}
              isEditable={props.isEditAllowed}
              translations={props.translations.products}
              onClick={props.onClick}
              isRounded
              tags={props.tags}
              isInnovative={props.isInnovative}
              imageDataDtm={props.imageDataDtm}
              trackProductInteractedEvent={trackProductInteractedEvent}
              isNew={props.isNew}
              isVideoAvailable={isVideoAvailable}
            />
          </MediaQuery>
          {
            props.displayLink ? getProductDetailsPageUrl(props.productDetailsUrlFormat) : displayProductName()
          }
          <ul className="producer-list">
            {displayProducerLink(props.product.producerDetails, props.artistDetailsUrlFormat)}
          </ul>
        </div>}
    </div>);
};

ProductCarouselItem.propTypes = {
  product: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  tags: PropTypes.object.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  classNames: PropTypes.string.isRequired,
  isInnovative: PropTypes.bool,
  isNew: PropTypes.bool,
  deviceType: PropTypes.shape({
    extraLarge: PropTypes.string.isRequired,
    large: PropTypes.string.isRequired,
    tablet: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired
  }).isRequired,
  productDetailsUrlFormat: PropTypes.string,
  artistDetailsUrlFormat: PropTypes.string,
  displayLink: PropTypes.bool,
  imageDataDtm: PropTypes.object,
  mixpanelProps: PropTypes.string
};

export default ProductCarouselItem;
